import { NgClass } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	input,
	output,
	ViewEncapsulation,
} from '@angular/core';

import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [SVG_ICON_IMPORTS, NgClass],
	selector: 'vp-tile',
	templateUrl: './tile.html',
})
export class TileComponent {
	icon = input.required<string>();
	id = input.required<string>();
	title = input.required<string>();

	preventClickEvents = input<boolean>(false);

	emitClick = output<void>();

	openLink(): void {
		this.emitClick.emit();
	}
}
